import React, { useEffect, useState } from "react";
import SkillCard from "./SkillCard";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import "./Skill.css";
import "../../style.css"
import useSkillLogic from "./SkillLogic";

const Skill = () => {
  const [familiar, setFamiliar] = useState([]);
  const [tools, setTools] = useState([]);
  const [comfortable, setComfortable] = useState([]);
  const [expertise, setExpertise] = useState([]);
  useEffect(() => {
    // Dynamically import the skill data when the component mounts
    Promise.all([
      import("./skillData").then((module) => module.familiar),
      import("./skillData").then((module) => module.tools),
      import("./skillData").then((module) => module.comfortable),
      import("./skillData").then((module) => module.expertise),
    ]).then(([familiarData, toolsData, comfortableData, expertiseData]) => {
      // Store the imported data in state
      setFamiliar(familiarData);
      setTools(toolsData);
      setComfortable(comfortableData);
      setExpertise(expertiseData);
    });
  }, []);

  const expertiseLogic = useSkillLogic(expertise);
  const comfortableLogic = useSkillLogic(comfortable);
  const familiarLogic = useSkillLogic(familiar);
  const toolsLogic = useSkillLogic(tools);

  return (
    <div id="skill" className="mt-16 text-accent">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
        <div
          // data-aos="fade-down"
          // data-aos-duration="1500"
          className="skill-container"
        >
          <h2 className="slide-title">Expertise</h2>
          <div className="flex flex-wrap justify-center gap-5 pb-5">
            {expertiseLogic.renderSkills().map((skill) => (
              <SkillCard key={skill.id} skill={skill} />
            ))}
          </div>
          <div className="pagination  flex justify-center">
            <button
              className="pagination-button"
              onClick={expertiseLogic.handlePrevPage}
              disabled={expertiseLogic.currentPage === 0}
            >
              <FaArrowLeft className="pagination-icon" />
            </button>
            <button
              className="pagination-button"
              onClick={expertiseLogic.handleNextPage}
              disabled={
                expertiseLogic.currentPage === expertiseLogic.totalPages - 1
              }
            >
              <FaArrowRight className="pagination-icon" />
            </button>
          </div>
        </div>
        <div
          data-aos="fade-down"
          data-aos-duration="1500"
          className="skill-container"
        >
          <h2 className="slide-title">Comfortable</h2>
          <div className=" flex flex-wrap justify-center gap-5 pb-5">
            {comfortableLogic.renderSkills().map((skill) => (
              <SkillCard key={skill.id} skill={skill} />
            ))}
          </div>
          <div className="pagination flex justify-center">
            <button
              className="pagination-button"
              onClick={comfortableLogic.handlePrevPage}
              disabled={comfortableLogic.currentPage === 0}
            >
              <FaArrowLeft className="pagination-icon" />
            </button>
            <button
              className="pagination-button"
              onClick={comfortableLogic.handleNextPage}
              disabled={
                comfortableLogic.currentPage ===
                comfortableLogic.totalPages - 1
              }
            >
              <FaArrowRight className="pagination-icon" />
            </button>
          </div>
        </div>
        <div
          data-aos="fade-up"
          data-aos-duration="1500"
          className="skill-container"
        >
             <h2 className="slide-title">FAMILIAR</h2>
          <div className="flex flex-wrap justify-center gap-5 pb-5">
            {familiarLogic.renderSkills().map((skill) => (
              <SkillCard key={skill.id} skill={skill} />
            ))}
          </div>
          <div className="pagination  flex justify-center">
            <button
              className="pagination-button"
              onClick={familiarLogic.handlePrevPage}
              disabled={familiarLogic.currentPage === 0}
            >
              <FaArrowLeft className="pagination-icon" />
            </button>
            <button
              className="pagination-button"
              onClick={familiarLogic.handleNextPage}
              disabled={familiarLogic.currentPage === familiarLogic.totalPages - 1}
            >
              <FaArrowRight className="pagination-icon" />
            </button>
          </div>
        </div>
        <div
          data-aos="fade-up"
          data-aos-duration="1500"
          className="skill-container"
        >
             <h2 className="slide-title">TOOLS</h2>
          <div className="flex flex-wrap justify-center gap-5 pb-5">
            {toolsLogic.renderSkills().map((skill) => (
              <SkillCard key={skill.id} skill={skill} />
            ))}
          </div>
          <div className="pagination  flex justify-center">
            <button
              className="pagination-button "
              onClick={toolsLogic.handlePrevPage}
              disabled={toolsLogic.currentPage === 0}
            >
              <FaArrowLeft className="pagination-icon" />
            </button>
            <button
              className="pagination-button"
              onClick={toolsLogic.handleNextPage}
              disabled={toolsLogic.currentPage === toolsLogic.totalPages - 1}
            >
              <FaArrowRight className="pagination-icon" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skill;
